import { useSharedState } from "composables/useSharedState";
import { useUidAttribute } from "composables/useUidAttribute";
import { tableHeadVariants } from "./Table.styles";

export const useTableHead = () => {
  useUidAttribute();
  useSharedState({});
  const classes = tableHeadVariants();
  return { classes };
};
